module.exports = __webpack_public_path__ + "static/42-ed3f81d28971a7269d36cf50dd7e80b4.png";